import { useMemo } from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import type { FieldMeta } from '../api/types';
import { useAppDispatch, useAppState } from '../store/hooks';
import { useContractTemplates } from '../contract/useContractTemplates';
import { PreviewPane } from '../components/PreviewPane';
import { ContractPreview } from '../components/ContractMode/ContractPreview';

interface Props {
  fieldMetas: FieldMeta[];
}

export function PreviewPage({ fieldMetas }: Props) {
  const state = useAppState();
  const dispatch = useAppDispatch();
  const contractTpl = useContractTemplates(state.context?.tableId ?? null);
  const isContract = state.mode === 'contract';

  const currentContract = useMemo(
    () =>
      contractTpl.selectedId
        ? contractTpl.templates.find((t) => t.id === contractTpl.selectedId) ?? null
        : null,
    [contractTpl.selectedId, contractTpl.templates],
  );

  const onBack = () => dispatch({ type: 'NAV', view: 'home' });

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        background: 'var(--canvas-bg)',
      }}
    >
      <div
        style={{
          padding: '10px 12px',
          background: 'var(--surface-1)',
          borderBottom: '1px solid var(--border)',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <Button shape="circle" type="text" icon={<LeftOutlined />} onClick={onBack} />
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600 }}>全屏预览</div>
          <div
            style={{
              fontSize: 10.5,
              color: 'var(--ink-3)',
              fontFamily: 'var(--font-mono)',
            }}
          >
            {isContract ? '模板' : '视图模板'} · {state.settings.paperSize}{' '}
            {state.settings.orientation === 'portrait' ? '纵向' : '横向'}
          </div>
        </div>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
          padding: '12px 16px 16px',
        }}
        className="pp-scroll"
      >
        {isContract ? (
          <ContractPreview
            context={state.context}
            recordId={state.contractRecordId}
            template={currentContract}
            fieldMetas={fieldMetas}
          />
        ) : (
          <PreviewPane fieldMetas={fieldMetas} />
        )}
      </div>
    </div>
  );
}
